// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"607acde0","912":"b99e4ca4"}[chunkId] + ".chunk.css";
};